import React, { useEffect, useState } from "react";
import "../RuwiBranch/RuwiBranch.scss";
import { PiBaseballHelmetLight } from "react-icons/pi";
import { FaChevronRight } from "react-icons/fa6";
import { AiOutlineEdit } from "react-icons/ai";
import { MdArrowDropDown } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import { FcCheckmark } from "react-icons/fc";
import { FaCirclePlus } from "react-icons/fa6";
import { GoPlus } from "react-icons/go";
import { RiUploadCloud2Fill } from "react-icons/ri";
import { IoIosCloseCircle } from "react-icons/io";
import axios from "axios";
import {
  createProduct,
  deleteProduct,
  deleteProductCategory,
  deletebrand,
  fetchRuwibranch,
  putProductCategory,
  putProductbrand,
  updateProduct,
} from "../../Services/BackendUrl";
import { CiCirclePlus } from "react-icons/ci";
import DeletePopup from "../Components/DeletePopup";
import Addpopup from "../Components/AddPopup";
import Updatepopup from "../Components/UpdatePopup";
import { InputText } from "primereact/inputtext";
import { encryptedAuth } from "../../Services/EncryptData";

const RuwiBranch = () => {
  const [shopData, setShopData] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSport, setSelectedSport] = useState("");
  const [categories, setCategories] = useState([]);
  const [isEdit, setIsedit] = useState(false);
  const [isField, setIsfield] = useState(true);
  const [isBrandfield, setIsbrnadfield] = useState(true);
  const [isAddbrand, setAddbrand] = useState(false);
  const [isEditsports, setIseditsports] = useState(false);
  const [categoryName, setCategoryname] = useState("");
  const [brandName, setBrandname] = useState("");
  const [isAddproduct, setIsaddproduct] = useState(false);
  const [isBrandtickmark, setIsbrandtickmark] = useState(false);
  const [isEditCategory, setIseditCategory] = useState(false);
  const [editedCategories, setEditedCategories] = useState({});
  const [editedBrand, setEditedbrand] = useState({});
  const [editingProduct, setEditingProduct] = useState(null);
  const [productName, setProductName] = useState("");
  const [price, setPrice] = useState("");
  const [discountPercentage, setDiscount] = useState("");
  const [imageData, setimageData] = useState("");
  const [isimageEdit, setimageEdit] = useState(false);
  const [isimagePrev, setimagePrev] = useState(false);
  const [showDeletepopup, setshowDeletepopup] = useState(false);
  const [showAddpopup, setshowAddpopup] = useState(false);
  const [showUpdatepopup, setshowUpdatapopup] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [brandToDelete, setBrandToDelete] = useState(null);
  const [categoryToUpdate, setCategoryUpdate] = useState(null);
  const [brandToUpdate, setBrandUpdate] = useState(null);
  const [showHiddenBrands, setShowHiddenBrands] = useState(false);
  const [prodcuctToDelete, setProductToDelete] = useState(null);


useEffect(() => {
  if (categories.length > 0) {
    setSelectedSport((prevSport) => {
      // check if previous selectedSport still exists
      const exists = categories.some(cat => cat.categoryName === prevSport);
      if (exists) {
        return prevSport; // keep current sport
      } else {
        return categories[0].categoryName; // fallback
      }
    });
  }
}, [categories]);


    const fetchProduct = async () => {
    try {
      const response = await axios.get(fetchRuwibranch);
      setShopData(response.data);
      setCategories(response.data.categories);
    } catch { }
  };


  const addCategoryname = async () => {
    try {
      await axios.post(
        createProduct,
        {
          shopName: "KOSMOS RUWI BRANCH",
          categories: [
            {
              categoryName: categoryName,
              brands: [],
            },
          ],
        },
        {
          headers: { "Content-Type": "application/json",
          Authorization : `Encrypted ${encryptedAuth}` },
        }
      );
      setIsfield(true);
      setshowAddpopup(false);
      fetchProduct();
      setCategoryname("");
    } catch { }
  };

  const handleAddbrand = async () => {
    try {
      await axios.post(
        createProduct,
        {
          shopName: "KOSMOS RUWI BRANCH",
          categories: [
            {
              categoryName: selectedSport,
              brands: [{ brandName: brandName, products: [] }],
            },
          ],
        },
        {
          headers: { "Content-Type": "application/json",
          Authorization : `Encrypted ${encryptedAuth}`},
        }
      );
      setIsbrnadfield(true);
      setBrandname(null);
      setshowAddpopup(false);
      fetchProduct();
      setAddbrand(null);
    } catch { }
  };

  const deleteCategory = async (categoryId) => {
    try {
      await axios.delete(deleteProductCategory, {
        params: { categoryId },
        headers: {
          Authorization : `Encrypted ${encryptedAuth}`
        },
      });
      fetchProduct();
      setSelectedSport('');
      setSelectedBrand('')
      setshowDeletepopup(false);
    } catch (error) {
      alert("Failed to delete");
    }
  };

  const deleteBrand = async (brandId) => {
    try {
      await axios.delete(deletebrand, {
        params: { brandId },
        headers: {
          Authorization : `Encrypted ${encryptedAuth}`
        },
      });

      fetchProduct();
      setshowDeletepopup(false);
    } catch (error) {
      alert("Failed to delete");
    }
  };

  const putCategory = async (categoryId, categoryName) => {
    try {
      await axios.put(
        putProductCategory,
        { categoryName },
        {
          params: {
            categoryId,
          },
          headers: {
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );
      fetchProduct();
    } catch { }
  };

  const updateBrand = async (brandId, brandName) => {
    try {
      await axios.put(
        putProductbrand,
        { brandName },
        {
          params: {
            brandId,
          },
          headers: {
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );
      fetchProduct();
    } catch (error) {
      alert("error");
    }
  };

// Helper: Convert image URL to Base64 string
const urlToBase64 = async (imageUrl) => {
  const response = await fetch(imageUrl,{
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
        Origin: window.location.origin,
    },
});
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1]; // remove prefix
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const handleupdateProduct = async () => {
  try {
    let finalImageData = imageData?.trim();

    // If no new image, get old one from product.imageUrl and convert
    if (!finalImageData) {
      finalImageData = await urlToBase64(editingProduct.imageUrl);
    }

    const updatedProduct = {
      productId: editingProduct.productId,
      productName:
        productName[editingProduct.productId] ?? editingProduct.productName,
      price: price[editingProduct.productId] ?? editingProduct.price,
      discountPercentage:
        discountPercentage[editingProduct.productId] ??
        editingProduct.discountPercentage,
      imageData: finalImageData,
    };

    await axios.put(updateProduct, updatedProduct, {
      headers: { "Content-Type": "application/json" ,
      Authorization : `Encrypted ${encryptedAuth}`},
    });

    setshowUpdatapopup(false);
    fetchProduct();
    setEditingProduct(null);
    setimageData("");
  } catch (error) {
    console.error("Error updating product:", error);
  }
};

  const handleDeleteproduct = async (productIds) => {
    try {
      await axios.post(
        deleteProduct,
        { productIds: [productIds] },
        {
          headers: {
            "content-Type": "application/json",
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );

      fetchProduct();
      setshowDeletepopup(false);
    } catch { }
  };



  useEffect(() => {
    fetchProduct();
  }, []);

  


   useEffect(() => {
   if (selectedSport && shopData?.categories) {
     const matchedCategory = shopData.categories.find(
       (category) => category.categoryName === selectedSport
     );
 
     if (matchedCategory && matchedCategory.brands?.length > 0) {
       setSelectedBrand((prevBrand) => {
         // check if previously selected brand still exists
         const existingBrand = matchedCategory.brands.find(
           (brand) => brand.brandName === prevBrand?.brandName
         );
         return existingBrand || matchedCategory.brands[0]; // keep or fallback
       });
     }
   }
 }, [selectedSport, shopData]);

  

  const handleSubmit = async () => {
    const payload = {
      shopName: "KOSMOS RUWI BRANCH",
      categories: [
        {
          categoryName: selectedSport,
          brands: [
            {
              brandName: selectedBrand.brandName,
              products: [
                {
                  productName,
                  imageData,
                  price: parseFloat(price),
                  discountPercentage: parseFloat(discountPercentage),
                },
              ],
            },
          ],
        },
      ],
    };
    try {
      await axios.post(createProduct, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization : `Encrypted ${encryptedAuth}`
        },
      });
      setshowAddpopup(false);
      fetchProduct();

      setshowAddpopup(false);
      setIsaddproduct(false);
      setProductName("");
      setPrice("");
      setDiscount("");
      setimageData("");
    } 
    catch(error) {
      console.error("Error uploading product",error) 
    }
  };

  const deletePopup = (sportsname) => {
    setCategoryToDelete(sportsname);
    setshowDeletepopup(true);
  };
  const handleConfirmDelete = () => {
    if (categoryToDelete) {
      deleteCategory(categoryToDelete.categoryId);
      setCategoryToDelete(null);
    }
  };

  const deleteBrandpopup = (brand) => {
    setBrandToDelete(brand);
    setshowDeletepopup(true);
  };

  const handlebrandDelete = () => {
    if (brandToDelete) {
      deleteBrand(brandToDelete.brandId);
      setBrandToDelete(null);
    }
  };

  const deleteProductpopup = (product) => {
    setProductToDelete(product);
    setshowDeletepopup(true);
  };

  const handleProductDelete = () => {
    if (prodcuctToDelete) {
      handleDeleteproduct(prodcuctToDelete.productId);
      setProductToDelete(null);
    }
  };

  const updateCategorypopup = (sportsname, categoryName) => {
    setCategoryUpdate({ ...sportsname, categoryName });
    setshowUpdatapopup(true);
  };

  const handlecategoryUpdate = () => {
    if (categoryToUpdate) {
      putCategory(categoryToUpdate.categoryId, categoryToUpdate.categoryName);
      setshowUpdatapopup(null);
    }
  };

  const updateBrandpopup = (brand, brandName) => {
    setBrandUpdate({ ...brand, brandName });
    setshowUpdatapopup(true);
  };

  const handlebrandUpdate = () => {
    if (brandToUpdate) {
      updateBrand(brandToUpdate.brandId, brandToUpdate.brandName);
      setshowUpdatapopup(null);
    }
  };

  return (
    <>
      <div className="ruwibranch-main-container">
        <div style={{ color: "white", fontSize: "1.3rem" }}>
          {shopData?.shopName}
        </div>
        <div className="update-container">
          <div className="sports-name">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="ruwi-sport-header">
                <PiBaseballHelmetLight
                  size={35}
                  style={{
                    background: "white",
                    color: "black",
                    borderRadius: "25px",
                    padding: "5px",
                  }}
                />
                All Sports
              </div>
              <div>
                {!isEditsports ? (
                  <div>
                    <AiOutlineEdit
                      onClick={() => setIseditsports(true)}
                      style={{
                        background: "#7FC5FF1A",
                        padding: "9px",
                        borderRadius: "25px",
                        color: "white",
                        cursor:'pointer'
                      }}
                      size={45}
                    />
                  </div>
                ) : (
                  <div>
                    <IoCloseOutline
                      onClick={() => {setIseditsports(false)}}
                      style={{
                        background: "white",
                        padding: "9px",
                        borderRadius: "25px",
                        color: "black",
                        cursor:'pointer'
                      }}
                      size={45}
                    />
                  </div>
                )}
              </div>
            </div>
            {!isEditsports ? (
              <ul className="sports-item">
                {shopData &&
                  shopData.categories?.map((sportsname) => (
                    <div
                      key={sportsname.categoryName}
                      className="sports-list-wrapper"
                      onClick={() => {setSelectedSport(sportsname.categoryName);setSelectedBrand("")}}
                    >
                      <li>{sportsname.categoryName} </li> <FaChevronRight />
                    </div>
                  ))}
              </ul>
            ) : (
              <ul className="sports-item-editmode">
                {shopData &&
                  shopData.categories?.map((sportsname) => (
                    <div
                      key={sportsname.categoryId}
                      className="sports-list-wrapper"
                    >
                      <input
                        type="text"
                        value={
                          editedCategories[sportsname.categoryId] ??
                          sportsname.categoryName
                        }
                        onChange={(e) => {
                          setIseditCategory(sportsname.categoryName);
                          setEditedCategories((prev) => ({
                            ...prev,
                            [sportsname.categoryId]: e.target.value,
                          }));
                        }}
                      />
                      <span>
                        {isEditCategory === sportsname.categoryName ? (
                          <div>
                            <FcCheckmark
                              onClick={() => {
                                const categoryName =
                                  editedCategories[sportsname.categoryId];
                                updateCategorypopup(sportsname, categoryName);
                              }}
                              style={{
                                color: "black",
                                borderRadius: "25px",
                                padding: "2px",
                                marginTop: "20px",
                                cursor:'pointer'
                              }}
                              size={25}
                            />{" "}
                          </div>
                        ) : (
                          <div>
                            <IoCloseOutline
                              onClick={() => {
                                deletePopup(sportsname);
                              }}
                              style={{
                                color: "black",
                                backgroundColor: "white",
                                borderRadius: "25px",
                                padding: "2px",
                                marginTop: "20px",
                                cursor:'pointer'
                              }}
                              size={20}
                            />{" "}
                          </div>
                        )}
                      </span>
                    </div>
                  ))}
                <div style={{ display: !isField ? "block" : "none" }}>
                  <input
                    name="categoryName"
                    value={categoryName}
                    onChange={(e) => setCategoryname(e.target.value)}
                    maxLength={20}
                  />
                  <FcCheckmark
                    size={25}
                    style={{ marginLeft: "25px",cursor:'pointer'}}
                    onClick={() => setshowAddpopup(true)}
                  />
                </div>
                <button
                  onClick={() => setIsfield(!isField)}
                  style={{
                    backgroundColor: "transparent",
                    border: "1px solid #0AB1E9",
                    width: "200px",
                    marginTop: "20px",
                    padding: "10px",
                    color: "#0AB1E9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    fontSize: "1rem",
                    borderRadius: "5px",
                    cursor:'pointer'
                  }}
                >
                  <FaCirclePlus /> Add New
                </button>
              </ul>
            )}
          </div>
          <div className="edit-product">
            <div className="edit-header">
              {selectedSport.length > 0 && (
              <div className="edit-product-header">
              <div>
                <h1 style={{ textTransform: "uppercase" }}>
                  {selectedSport}
                </h1>
                <p style={{ color: "#C1C1C1" }}>
                  Add new product for the branch
                </p>
              </div>
              {!isEdit ? (
                <div>
                  <AiOutlineEdit
                    onClick={() => setIsedit(true)}
                    style={{
                      background: "#7FC5FF1A",
                      padding: "9px",
                      borderRadius: "25px",
                      cursor:'pointer'
                    }}
                    size={45}
                  />
                </div>
              ) : (
                <div>
                  <IoCloseOutline
                    onClick={() => {setIsedit(false); setAddbrand(false)}}
                    style={{
                      background: "white",
                      padding: "9px",
                      borderRadius: "25px",
                      color: "black",
                      cursor:'pointer'
                    }}
                    size={45}
                  />
                </div>
              )}
            </div>
              )}

              {!isEdit ? (
                <div
                  style={{
                    paddingTop: "10px",
                  }}
                >
                  {shopData?.categories
                    ?.filter(
                      (category) => category.categoryName === selectedSport
                    )
                    .map((category) => {
                      const brands = category.brands || [];
                      const visibleBrands = brands.slice(0, 5);
                      const hiddenBrands = brands.slice(5);
                      return (
                        <div
                          key={category._id || category.categoryName}
                          style={{ display: "flex",
                          justifyContent : 'space-between',
                          position:'relative' }}
                        >
                          {brands.length > 0 && (
                          <div className="sports-brand">
                          {visibleBrands.map((brand) => (
                            <span
                              key={brand._id || brand.brandName}
                              style={{
                                cursor: "pointer",
                                padding: "10px 0px",
                                color:
                                  selectedBrand?.brandName === brand.brandName
                                    ? "white"
                                    : "",
                              }}
                              onClick={() => setSelectedBrand(brand)}
                            >
                              {brand.brandName}
                            </span>
                          ))}
                        </div>
                          )}

                          {hiddenBrands.length > 0 && (
                            <div className="brand-dropdown"
                            onClick={() =>
                              setShowHiddenBrands(!showHiddenBrands)
                            }>
                              <MdArrowDropDown
                                size={35}
                              />

                              {showHiddenBrands && (
                                <div
                                  style={{
                                    position: "absolute",
                                    marginTop: "20px",
                                    marginLeft : '-25px',
                                    backgroundColor: "white",
                                    color: "black",
                                    border: "1px solid #0BB1E9",
                                    borderRadius: "5px",
                                    padding: "10px",
                                    zIndex: 10,
                                    maxHeight: "500px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {hiddenBrands.map((brand) => (
                                    <div
                                      key={brand._id || brand.brandName}
                                      style={{
                                        padding: "5px 10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setSelectedBrand(brand);
                                        setShowHiddenBrands(false);
                                      }}
                                    >
                                      {brand.brandName}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div
                  style={{
                    paddingTop: "10px",
                  }}
                >
                  {shopData?.categories
                    ?.filter(
                      (category) => category.categoryName === selectedSport
                    )
                    .map((category) => {
                      const brands = category.brands || [];
                      const visibleBrands = brands.slice(0, 4);
                      const hiddenBrands = brands.slice(4);
                      return (
                        <div
                          key={category._id || category.categoryName}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                            justifyContent : 'space-between'
                          }}
                        >
                          {brands.length > 0 && (
                          <div className="sports-brand">
                          {visibleBrands.map((brand) => (
                            <div style={{ display: "flex" }} key={brand._id}>
                              <span>
                                <input
                                  value={
                                    editedBrand[brand.brandId] ??
                                    brand.brandName
                                  }
                                  maxLength={20}
                                  onChange={(e) => {
                                    setIsbrandtickmark(brand.brandName);
                                    setEditedbrand((prev) => ({
                                      ...prev,
                                      [brand.brandId]: e.target.value,
                                    }));
                                  }}
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "1px solid white",
                                    padding: "5px",
                                    color: "white",
                                    width: "70px",
                                    borderRadius: "5px",
                                  }}
                                />
                              </span>
                              <IoCloseOutline
                                style={{cursor:'pointer'}}
                                onClick={() => {
                                  deleteBrandpopup(brand);
                                }}
                                className="edit-close-icon"
                              />
                              {isBrandtickmark === brand.brandName ? (
                                <FcCheckmark
                                  style={{cursor:'pointer'}}
                                  onClick={() => {
                                    const brandName =
                                      editedBrand[brand.brandId];
                                    updateBrandpopup(brand, brandName);
                                  }}
                                  size={20}
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          ))}
                        </div>
                          )}


                          {hiddenBrands && (
                            <div
                              onClick={() => {
                                setAddbrand(!isAddbrand);
                                setShowHiddenBrands(!showHiddenBrands);
                              }}
                              className="edit-brand-dropdown"
                              style={{
                                backgroundColor: isAddbrand ? "white" : "",
                                color: "black",
                                border: "none",
                              }}
                            >
                              <GoPlus size={35} style={{ cursor: "pointer" }} />
                              {isAddbrand && (
                                <div
                                className={brands.length > 0 ? "add-brand-right" :'add-brand-left'} 
                                >
                                  <h3 style={{ color: "#343434" }}>BRANDS</h3>
                                  <div>
                                    {showHiddenBrands && (
                                      <div>
                                        {hiddenBrands.map((brand) => (
                                          <div style={{ padding: "5px 0px" }}>
                                            <input
                                              value={
                                                editedBrand[brand.brandId] ??
                                                brand.brandName
                                              }
                                              maxLength={20}
                                              onChange={(e) => {
                                                setIsbrandtickmark(
                                                  brand.brandName
                                                );
                                                setEditedbrand((prev) => ({
                                                  ...prev,
                                                  [brand.brandId]:
                                                    e.target.value,
                                                }));
                                              }}
                                              style={{
                                                backgroundColor: "transparent",
                                                border: "1px solid gray",
                                                padding: "10px",
                                                color: "black",
                                                borderRadius: "5px",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                              }}
                                            />
                                            {isBrandtickmark ===
                                              brand.brandName ? (
                                              <FcCheckmark
                                                onClick={(e) => {
                                                  const brandName =
                                                    editedBrand[brand.brandId];
                                                  updateBrandpopup(
                                                    brand,
                                                    brandName
                                                  );
                                                  e.stopPropagation();
                                                }}
                                                size={20}
                                                style={{ marginLeft: "25px", cursor:'pointer'}}
                                              />
                                            ) : (
                                              <IoCloseOutline
                                                onClick={(e) => {
                                                  deleteBrandpopup(brand);
                                                  e.stopPropagation();
                                                }}
                                                style={{
                                                  backgroundColor: "red",
                                                  color: "white",
                                                  borderRadius: "25px",
                                                  marginLeft: "20px",
                                                  cursor:'pointer'
                                                }}
                                              />
                                            )}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      display: !isBrandfield ? "block" : "none",
                                    }}
                                  >
                                    <input
                                      name="brandName"
                                      value={brandName}
                                      onChange={(e) => {
                                        setBrandname(e.target.value);
                                      }}
                                      maxLength={20}
                                      onClick={(e) => e.stopPropagation()}
                                      style={{
                                        backgroundColor: "transparent",
                                        border: "1px solid #0AB1E9",
                                        marginTop: "20px",
                                        padding: "10px",
                                        borderRadius: "5px",
                                      }}
                                    />
                                    <FcCheckmark
                                      size={25}
                                      style={{ marginLeft: "20px", cursor:'pointer' }}
                                      onClick={() => {
                                        setshowAddpopup(true);
                                        setIsedit(false);
                                      }}
                                    />
                                  </div>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setIsbrnadfield(!isBrandfield);
                                    }}
                                    style={{
                                      backgroundColor: "#05B8E6",
                                      border: "1px solid #0AB1E9",
                                      marginTop: "20px",
                                      padding: "10px",
                                      color: "white",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "10px",
                                      fontSize: "1rem",
                                      borderRadius: "5px",
                                      width: "100%",
                                      cursor:'pointer'
                                    }}
                                  >
                                    <GoPlus
                                      style={{
                                        backgroundColor: "white",
                                        color: "black",
                                        borderRadius: "25px",
                                      }}
                                    />{" "}
                                    Add New
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
            {!isEdit ? selectedBrand?.brandName &&  (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "white",
                    padding: "0px 20px",
                  }}
                >
                  <span>
                    <h1>{selectedBrand?.brandName}</h1>
                    <small>Products of {selectedBrand?.brandName}</small>
                  </span>
                  <span
                    onClick={() => setIsaddproduct(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        display: "flex",
                        padding: "10px",
                        gap: "5px",
                        borderRadius: "25px",
                        alignItems: "center",
                      }}
                    >
                      <CiCirclePlus size={30} /> Add Product
                    </div>
                  </span>
                </div>
              </div>
            ) : (
              <div>
                { selectedBrand?.brandName && (
                <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "white",
                  padding: "0px 20px",
                }}
              >
                <span>
                  <h1>{selectedBrand?.brandName}</h1>
                  <small>Products of {selectedBrand?.brandName}</small>
                </span>
                <span
                  onClick={() => {
                    setIsaddproduct(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      color: "black",
                      display: "flex",
                      padding: "10px",
                      gap: "5px",
                      borderRadius: "25px",
                      alignItems: "center",
                    }}
                  >
                    <CiCirclePlus size={30} /> Add Product
                  </div>
                </span>
              </div>
                )}
              </div>
            )}

            {!isAddproduct &&
              selectedBrand?.products?.map((product, productId) => (
                <div key={product.productName}>
                  {editingProduct?.productName === product.productName ? (
                    <div style={{ position: "relative" }}>
                      <IoIosCloseCircle
                        className="edit-close-icon"
                        onClick={() => {
                          setimageEdit(true);
                          setimagePrev(true);
                          setimageData(null);
                        }}
                        style={{
                          color: "red",
                          position:'absolute',
                          marginLeft:'240px',
                          top:'20px',
                          display: isimageEdit ? "none" : "",
                          cursor:'pointer'
                        }}
                        size={25}
                      />
                      <div className="edit-view-product-section">
                        {!isimageEdit && (
                          <div className="image-background">
                            <img
                              src={product.imageUrl}
                              alt=""
                              width={230}
                              height={200}
                            />
                          </div>
                        )}
                        {isimageEdit && isimagePrev && (
                          <div
                            className={`edit-upload-image ${
                              imageData ? "no-padding" : ""
                            }`}
                            onClick={() =>
                              document
                                .getElementById("productImageInput")
                                .click()
                            }
                          >
                            <input
                              id="productImageInput"
                              type="file"
                              accept="image/*"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (!file) return;
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  const base64String =
                                    reader.result.split(",")[1];
                                  setimageData(base64String);
                                };
                                reader.readAsDataURL(file);
                              }}
                            />
                            {imageData ? (
                              <img
                                src={`data:image/*;base64,${imageData}`}
                                alt="Selected"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "100%",
                                  objectFit: "contain",
                                  borderRadius: "8px",
                                }}
                              />
                            ) : (
                              <div>
                                {" "}
                                <span>
                                  <RiUploadCloud2Fill
                                    size={50}
                                    style={{ color: "white" }}
                                  />
                                </span>
                                <p>Upload the product image</p>
                                <small style={{ color: "gray" }}>
                                  Size upto 15mb
                                </small>
                              </div>
                            )}
                          </div>
                        )}
                        <div
                          key={productId}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                            gap: "20px",
                          }}
                        >
                          <div style={{ display: "flex", gap: "50px" }}>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <label className="product-label">
                                Product Name
                              </label>
                              <input
                                className="product-edit-input"
                                value={
                                  productName[product.productId] ??
                                  product.productName
                                }
                                maxLength={20}
                                onChange={(e) =>
                                  setProductName((prev) => ({
                                    ...prev,
                                    [product.productId]: e.target.value,
                                  }))
                                }
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <label className="product-label">
                                Price Amount
                              </label>
                              <input
                                className="product-edit-input"
                                value={
                                  price[product.productId] ?? product.price
                                }
                                maxLength={10}
                                onChange={(e) =>
                                  setPrice((prev) => ({
                                    ...prev,
                                    [product.productId]: e.target.value.replace(/\D/g, ''),
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <label className="product-label">Discount</label>
                            <input
                              className="product-edit-input"
                              value={
                                discountPercentage[product.productId] ??
                                product.discountPercentage
                              }
                              maxLength={3}
                              onChange={(e) =>
                                setDiscount((prev) => ({
                                  ...prev,
                                  [product.productId]: e.target.value.replace(/\D/g, ''),
                                }))
                              }
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "30px",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              onClick={() => {
                                setimageEdit(false);
                                setEditingProduct(false);
                              }}
                              style={{
                                backgroundColor: "transparent",
                                border: "1px solid #0BB1E9",
                                color: "white",
                                padding: "10px 35px",
                                borderRadius: "5px",
                                fontSize: "1.1rem",
                                cursor:'pointer'
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => setshowUpdatapopup(true)}
                              style={{
                                backgroundColor: "#0BB1E9",
                                color: "white",
                                border: "none",
                                padding: "10px 35px",
                                borderRadius: "5px",
                                fontSize: "1.1rem",
                                cursor:'pointer'
                              }}
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="view-product-section">
                      <div className="image-background">
                        <img
                          src={product.imageUrl}
                          alt=""
                          width={230}
                          height={200}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <div style={{ display: "flex", gap: "50px" }}>
                          <div>
                            <label className="product-label">
                              Product Name
                            </label>
                            <p>{product.productName}</p>
                          </div>
                          <div>
                            <label className="product-label">
                              Price Amount
                            </label>
                            <p>{product.price}</p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <label className="product-label">Discount</label>
                            <p>{product.discountPercentage}</p>
                          </div>
                          <div>
                            <label className="product-label">
                              Discount Price
                            </label>
                            <p>{product.discountPrice.toFixed(2)}</p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "20px",
                          }}
                        >
                          <button
                            onClick={() => setEditingProduct(product)}
                            style={{
                              width: "100px",
                              padding: "10px",
                              backgroundColor: "rgba(5, 184, 230, 1)",
                              borderRadius: "5px",
                              border: "none",
                              color: "white",
                              alignItems: "flex-end",
                              cursor:'pointer'
                            }}
                          >
                            Edit
                          </button>
                          <button
                            onClick={() =>
                              deleteProductpopup(product)
                            }
                            style={{
                              width: "100px",
                              padding: "10px",
                              backgroundColor: "rgba(5, 184, 230, 1)",
                              borderRadius: "5px",
                              border: "none",
                              color: "white",
                              alignItems: "flex-end",
                              cursor:'pointer'
                            }}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}

            {isAddproduct && (
              <div style={{ color: "#0BB1E9", padding: "20px" }}>
                <div style={{ display: "flex", gap: "30px" }}>
                  <div
                    className={`edit-upload-image ${imageData ? "no-padding" : ""
                      }`}
                    onClick={() =>
                      document.getElementById("productImageInput").click()
                    }
                  >
                    <input
                      id="productImageInput"
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          const base64String = reader.result.split(",")[1];
                          setimageData(base64String);
                        };
                        reader.readAsDataURL(file);
                      }}
                    />
                    {imageData ? (
                      <img
                        src={`data:image/*;base64,${imageData}`}
                        alt="Selected"
                        style={{ width: "250px", borderRadius: "8px" }}
                      />
                    ) : (
                      <div>
                        {" "}
                        <span>
                          <RiUploadCloud2Fill
                            size={50}
                            style={{ color: "white" }}
                          />
                        </span>
                        <p>Upload the product image</p>
                        <small style={{ color: "gray" }}>Size upto 15mb</small>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-evenly",
                    }}
                  >
                    <div style={{ display: "flex", gap: "50px" }}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label className="product-label">Product Name</label>
                        <InputText
                          className="product-add-input"
                          onChange={(e) => setProductName(e.target.value)}
                          maxLength={20}
                        />
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label className="product-label">Price Amount</label>
                        <InputText
                          className="product-add-input"
                          onChange={(e) => setPrice(e.target.value)}
                          maxLength={10}
                          keyfilter='int'
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <label className="product-label">Discount</label>
                      <InputText
                        className="product-add-input"
                        onChange={(e) => setDiscount(e.target.value)}
                        maxLength={3}
                        keyfilter='int'
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "30px",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                  }}
                >
                  <button
                    onClick={() => {
                      setIsaddproduct(false);
                      setimageData(null);
                    }}
                    style={{
                      backgroundColor: "transparent",
                      border: "1px solid #0BB1E9",
                      color: "white",
                      padding: "10px 35px",
                      borderRadius: "5px",
                      fontSize: "1.1rem",
                      cursor:'pointer'
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    style={{
                      backgroundColor: "#0BB1E9",
                      color: "white",
                      border: "none",
                      padding: "10px 35px",
                      borderRadius: "5px",
                      fontSize: "1.1rem",
                      cursor:'pointer'
                    }}
                    onClick={() => setshowAddpopup(true)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div></div>
        <Addpopup
          visible={showAddpopup}
          onHide={() => setshowAddpopup(false)}
          onConfirm={() => {
            if (isAddproduct) {
              handleSubmit();
            } else {
              addCategoryname();
            }
            handleAddbrand();
          }}
        />
        <DeletePopup
          visible={showDeletepopup}
          onHide={() => setshowDeletepopup(false)}
          onConfirm={() => {
            handleProductDelete();
            handleConfirmDelete();
            handlebrandDelete();
          }}
        />
        <Updatepopup
          visible={showUpdatepopup}
          onHide={() => setshowUpdatapopup(false)}
          onConfirm={() => {
            handleupdateProduct();
            handlecategoryUpdate();
            handlebrandUpdate();
          }}
        />
      </div>
    </>
  );
};
export default RuwiBranch;
